import { Config } from '@/config';
import { ApiService } from '@/services/api.service';

class ProductBundleExtractionOutputFiles {
  getProductBundleExtractionOutputFile({ bundleId, fileId, cancelToken = null }) {
    return ApiService.get(
      `${Config.api.slipExtractor.url}api/v1/product-bundle-extractions/${bundleId}/output-files/${fileId}`,
      { cancelToken: cancelToken && cancelToken.token },
    ).then((response) => response.data);
  }
  downloadOutputFile({ bundleId, fileId, name }) {
    return ApiService.get(
      `${Config.api.slipExtractor.url}api/v1/product-bundle-extractions/${bundleId}/output-files/${fileId}/file`,
      { responseType: 'blob' },
    )
      .then((response) => {
        const blob = response.data;

        if (!(blob instanceof Blob)) {
          console.error('Error downloading file: Invalid blob object');
          return;
        }

        const blobUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = blobUrl;
        link.setAttribute('download', name);

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      })
      .catch((error) => {
        console.error('Error downloading file:', error);
      });
  }
  uploadOutputFile({ bundleId, files }) {
    const formData = new FormData();
    files.forEach((file) => {
      file.forEach((fileObject) => {
        if (fileObject && fileObject.name) {
          formData.append(`file[]`, fileObject);
        }
      });
    });

    return ApiService.post(
      `${Config.api.slipExtractor.url}api/v1/product-bundle-extractions/${bundleId}/output-files`,
      formData,
      {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'multipart/form-data',
        },
      },
    )
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        throw error;
      });
  }
  deleteExtractionOutputFileById({ bundleId, fileId }) {
    return ApiService.delete(
      `${Config.api.slipExtractor.url}api/v1/product-bundle-extractions/${bundleId}/output-files/${fileId}`,
    ).then((response) => response.data);
  }
}

export const productBundleExtractionOutputFilesService = new ProductBundleExtractionOutputFiles();
